<template>
    <el-dialog
      v-model="loginModalVisible"
      width="400px"
      :show-close="true"
      :close-on-click-modal="false"
      custom-class="auth-dialog login-dialog"
      :center="true"
    >
        <!-- 登录表单 -->
      <div class="auth-form-container" v-if="loginflag">
        <h2 class="auth-title">登录</h2>
        
        <div class="form-group">
          <el-input 
            v-model="loginForm.phone" 
            placeholder="请输入手机号" 
            class="auth-input"
          ></el-input>
        </div>

        <div class="form-group captcha-group">
          <el-input 
            v-model="loginForm.captcha" 
            placeholder="图片验证码" 
            class="auth-input captcha-input"
          ></el-input>
          <div class="captcha-image">
            <img class="captcha-text" :src="codeImg" alt="" id="img" />
            <span class="refresh-captcha" @click="refreshCaptcha">换一换</span>
          </div>
        </div>
        
        <div class="form-group">
          <el-input 
            v-model="loginForm.smsCode" 
            placeholder="请输入手机验证码" 
            class="auth-input"
          >
          <template #append>
            <el-button 
              @click="sendSmsCode" 
              :disabled="smsButtonDisabled"
              class="sms-btn"
            >
              {{ smsButtonText }}
            </el-button>
          </template>
            
          </el-input>
        </div>
        
        <el-button type="primary" class="auth-submit-btn" @click="submitLogin">登 录</el-button>
        
        <div class="auth-footer">
          <span>本系统由于 使用即同意</span>
          <a href="#" class="privacy-link" @click="showPrivacyModal">《江泰隐私条款声明》</a>
        </div>
        
        <div class="switch-auth">
          <a href="#" @click.prevent="switchToRegister">申请加入</a>
        </div>
      </div>
      <!-- 注册表单 -->
      <div class="auth-form-container" v-else>
        <h2 class="auth-title">申请加入</h2>
        
        <div class="form-group">
          <label class="required-label">手机号:</label>
          <el-input 
            v-model="registerForm.phone" 
            placeholder="请输入手机号" 
            class="auth-input"
          ></el-input>
        </div>
        
        <div class="form-group">
          <label class="required-label">图形验证码:</label>
          <div class="captcha-group">
            <el-input 
              v-model="registerForm.captcha" 
              placeholder="图片验证码" 
              class="auth-input captcha-input"
            ></el-input>
            <div class="captcha-image">
              <img class="captcha-text" :src="codeImg" alt="" id="img" />
              <span class="refresh-captcha" @click="refreshCaptcha">换一换</span>
            </div>
          </div>
        </div>
        
        <div class="form-group">
          <label class="required-label">手机验证码:</label>
          <el-input 
            v-model="registerForm.smsCode" 
            placeholder="请输入手机验证码" 
            class="auth-input"
          >
            <template #append>
              <el-button 
                @click="sendSmsCode" 
                :disabled="smsButtonDisabled"
                class="sms-btn"
              >
                {{ smsButtonText }}
              </el-button>
            </template>
          </el-input>
        </div>
        
        <div class="form-group">
          <label class="required-label">姓名:</label>
          <el-input 
            v-model="registerForm.name" 
            placeholder="请输入姓名" 
            class="auth-input"
          ></el-input>
        </div>
        
        <div class="form-group">
          <label class="required-label">单位:</label>
          <el-input 
            v-model="registerForm.company" 
            placeholder="" 
            class="auth-input"
          ></el-input>
        </div>
        
        <div class="form-group">
          <label class="required-label">职务:</label>
          <el-input 
            v-model="registerForm.position" 
            placeholder="" 
            class="auth-input"
          ></el-input>
        </div>
        
        <div class="form-group">
          <label class="required-label">邮箱:</label>
          <el-input 
            v-model="registerForm.email" 
            placeholder="" 
            class="auth-input"
          ></el-input>
        </div>
        
        <div class="form-group">
          <label class="required-label">类别:</label>
          <el-select v-model="registerForm.category" placeholder="" class="auth-input">
            <el-option label="个人" value="个人"></el-option>
            <el-option label="企业" value="企业"></el-option>
            <el-option label="合作伙伴" value="合作伙伴"></el-option>
            <el-option label="星使" value="星使"></el-option>
          </el-select>
        </div>
        
        <el-button type="primary" class="auth-submit-btn" @click="submitRegister">立即申请</el-button>
        
        <div class="auth-footer">
          <span>本系统由于 使用即同意</span>
          <a href="#" class="privacy-link" @click="showPrivacyModal">《江泰隐私条款声明》</a>
        </div>
        
        <div class="switch-auth">
          <a href="#" @click.prevent="switchToLogin">登录 <i class="el-icon-arrow-right"></i></a>
        </div>
      </div>
    </el-dialog>
</template>
<script>
import authService from '@/service/auth.service.js'
import {setLocalStorage} from '../utils/localstorageUtils';

export default {
  name: 'loginOrRegister',
  components: {
  },
  data() {
    return {
      codeImg: '',
      imgCode: '',
      menuActive: false,
      downloadHistoryVisible: false,
      currentPage: 1,
      total: 0,
      windowWidth: window.innerWidth,
      
      // Login modal
      loginModalVisible: false,
      loginForm: {
        phone: '',
        smsCode: '',
        captcha: ''
      },
      registerForm: {
        phone: '',
        smsCode: '',
        captcha: '',
        name: '',
        company: '',
        position: '',
        email: '',
        category: ''
      },
      
      // SMS verification
      smsButtonText: '获取验证码',
      smsButtonDisabled: false,
      smsCountdown: 60,
      smsTimer: null,
      
      // Captcha
      captchaLoading: false,
      
      // Sample download records data
      loginflag: true
    }
  },
  computed: {
  },
  methods: {
    // Authentication methods
    showLoginModal(flag) {
      this.loginModalVisible = true
      flag == 'login' ? this.loginflag = true : this.loginflag = false
      this.refreshCaptcha()
    },
    
    showRegisterModal() {
      this.loginflag = false
      this.refreshCaptcha()
    },
    
    switchToLogin() {
      clearInterval(this.smsTimer)
      this.smsCountdown = 60
      this.smsButtonDisabled = false
      this.smsButtonText = '获取验证码'
      this.loginflag = true
      this.resetInfo();
      this.refreshCaptcha()
    },
    
    switchToRegister() {
      clearInterval(this.smsTimer)
      this.smsCountdown = 60
      this.smsButtonDisabled = false
      this.smsButtonText = '获取验证码'
      this.loginflag = false
      this.resetInfo();
      this.refreshCaptcha()
    },

    resetInfo() {
      this.loginForm = {
        phone: '',
        smsCode: '',
        captcha: ''
      }
      this.registerForm = {
        phone: '',
        smsCode: '',
        captcha: '',
        name: '',
        company: '',
        position: '',
        email: '',
        category: ''
      }
    },
    
    sendSmsCode() {
      // Validate phone number first
      if (!this.validatePhone()) {
        this.$message.error('请输入有效的手机号码')
        return
      }
      this.sendSmsCodeRegisterFunc();
    },
    
    async sendSmsCodeFunc() {
      let params = {phoneNum:this.loginForm.phone,imageVerificationCode:this.loginForm.captcha}
      await authService.sendSmsCode(params,{"imgcode":this.imgCode}).then(res => {
        if(res.data.code == '0000'){
          this.$message.success('验证码已发送')
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },  
    
    async sendSmsCodeRegisterFunc() {
      let phoneNum = this.loginflag ? this.loginForm.phone : this.registerForm.phone;
      let imageVerificationCode = this.loginflag ? this.loginForm.captcha : this.registerForm.captcha;
      await authService.sendSmsCodeRegister({phoneNum:phoneNum,imageVerificationCode:imageVerificationCode},{"imgcode":this.imgCode}).then(res => {
        if(res.data.code == '0000'){
          this.smsButtonDisabled = true
          this.smsCountdown = 60
          this.smsButtonText = `${this.smsCountdown}秒后重试`
          
          this.smsTimer = setInterval(() => {
            this.smsCountdown--
            this.smsButtonText = `${this.smsCountdown}秒后重试`
            
            if (this.smsCountdown <= 0) {
              clearInterval(this.smsTimer)
              this.smsButtonDisabled = false
              this.smsButtonText = '获取验证码'
            }
          }, 1000)
          this.$message.success('验证码已发送')
        }else{
          this.refreshCaptcha();
          this.$message.error(res.data.msg)
        }
      })
    },
    refreshCaptcha() {
        this.getCaptcha();
    },
    
    validatePhone() {
      const phone = this.loginflag  ? this.loginForm.phone : this.registerForm.phone
      // Simple Chinese phone number validation
      return /^1[3-9]\d{9}$/.test(phone)
    },
    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    
    async submitLogin() {
      // Validate form
      if (!this.loginForm.phone) {
        this.$message.error('请输入手机号')
        return
      }

      if (!this.loginForm.captcha) {
        this.$message.error('请输入图形验证码')
        return
      }
      
      if (!this.loginForm.smsCode) {
        this.$message.error('请输入短信验证码')
        return
      }
      
      await authService.login({phoneNum:this.loginForm.phone,kaptchaCode:this.loginForm.smsCode,loginType:'1',sysCode:'ceggrc-web-2025'}).then(res => {
        if(res.data.code == '0000'){
          this.$message.success('登录成功');
          setLocalStorage(res.data.data);
          this.$parent.isLoggedIn = true
          this.$parent.userInfo = res.data.data.userName;
          this.loginModalVisible = false
          // 刷新页面以更新所有组件状态
          window.location.reload();
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    
    async submitRegister() {
      // Validate form
      if (!this.registerForm.phone) {
        this.$message.error('请输入手机号')
        return
      }
      
      if (!this.registerForm.captcha) {
        this.$message.error('请输入图形验证码')
        return
      }
      
      if (!this.registerForm.smsCode) {
        this.$message.error('请输入短信验证码')
        return
      }
      
      if (!this.registerForm.name) {
        this.$message.error('请输入姓名')
        return
      }
      
      if (!this.registerForm.company) {
        this.$message.error('请输入单位')
        return
      }

      if (!this.registerForm.position) {
        this.$message.error('请输入职务')
        return
      }
      //增加邮箱正确性校验  
      if (!this.registerForm.email || !this.validateEmail(this.registerForm.email)) {
        this.$message.error('请输入邮箱')
        return
      }
      
      if (!this.registerForm.category) {
        this.$message.error('请选择类别')
        return
      }
      
      await authService.registerLogin(
        {
          phoneNum:this.registerForm.phone,
          smsVerificationCode:this.registerForm.smsCode,
          channelCode:'home',
          sysCode:'ceggrc-web-2025',
          userSourceType:'49'
        }).then(res => {
        if(res.data.code == '0000'){
          setLocalStorage(res.data.data);
          this.registerInfoFunc(res.data.data);
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    async registerInfoFunc(data) {
      await authService.registerInfo(
        {
        "userCode": data.userCode,
        "ignoreIfExisting": "0",
        "returnIfExisting": "0",
        "actualName": this.registerForm.name,
        "userPhone": this.registerForm.phone,
        "email": this.registerForm.email,
        "channelCode": "home",
        "orgElementVOList": [
          {
            "elementCode": "unit",
            "elementName": "单位",
            "elementValues": this.registerForm.company
          },{
            "elementCode": "job_title",
            "elementName": "职务",
            "elementValues": this.registerForm.position
          },{
            "elementCode": "category",
            "elementName": "类别",
            "elementValues": this.registerForm.category
          }
        ]
      },{'authorization':data.token}).then(res => {
        if(res.data.code == '0000'){
          this.$parent.userInfo = this.registerForm.name;
          this.$message.success('申请已提交')
          this.$parent.isLoggedIn = true;
          this.loginModalVisible = false
          // 刷新页面以更新所有组件状态
          window.location.reload();
          // Reset form
          this.registerForm = {
            phone: '',
            smsCode: '',
            captcha: '',
            name: '',
            company: '',
            position: '',
            email: '',
            category: ''
          }
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },

    getCaptcha() {
      this.captchaLoading = true
      authService.getCaptcha()
        .then(res => {
          this.codeImg = res.data;
          this.imgCode = res.header.imgcode;
        })
        .catch(error => {
          console.error('获取验证码失败:', error)
          this.$message.error('获取验证码失败，请稍后重试')
        })
        .finally(() => {
          this.captchaLoading = false
        })
    },
    showPrivacyModal() {
      window.open( "/yinsishengming");
    }
  },
}
</script>
<style scoped>
/* Auth Dialog Styles */
.auth-form-container {
  padding: 10px 20px;
}

.auth-title {
  text-align: center;
  font-size: 20px;
  margin-bottom: 25px;
  color: #333;
}

.form-group {
  margin-bottom: 20px;
}

.required-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

.required-label::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

.auth-input {
  width: 100%;
}

.captcha-group {
  display: flex;
  align-items: center;
}

.captcha-input {
  flex: 1;
}

.captcha-image {
  margin-left: 10px;
  /* background-color: #f0f2f5; */
  padding: 8px 12px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  height: 40px;
}

.captcha-text {
  font-family: 'Courier New', monospace;
  font-weight: bold;
  font-size: 18px;
  color: #004a99;
  letter-spacing: 2px;
}

.refresh-captcha {
  margin-left: 10px;
  color: #004a99;
  font-size: 12px;
  cursor: pointer;
}

.auth-submit-btn {
  width: 100%;
  height: 40px;
  font-size: 16px;
  background-color: #004a99;
  border-color: #004a99;
}

.auth-footer {
  margin-top: 15px;
  text-align: center;
  font-size: 12px;
  color: #999;
}

.privacy-link {
  color: #004a99;
  text-decoration: none;
}

.switch-auth {
  margin-top: 15px;
  text-align: center;
}

.switch-auth a {
  color: #004a99;
  text-decoration: none;
  font-size: 14px;
}
@media (max-width: 767px) { 
  .auth-title {
    font-size: 18px;
    margin-bottom: 20px;
  }
  
  .captcha-image {
    padding: 6px 10px;
    height: 36px;
  }
  
  .captcha-text {
    font-size: 16px;
  }
  
  /deep/ .auth-dialog {
    width: 95% !important;
    margin: 0 auto;
  }
}

@media (max-width: 479px) {
  .form-group {
    margin-bottom: 15px;
  }
  
  .auth-submit-btn {
    height: 36px;
    font-size: 14px;
  }
}
</style>